export default __webpack_public_path__ + "static/11_32-00a62a17d3539f481c761a179b4f1a61.png";